import { FC } from 'react'
import { TabPanel } from 'react-tabs'
import CN from 'classnames'

import { ShippingLineSelection } from 'components/molecules/ShippingLineSelection'

export interface TabAusPostProps {
  className?: string | undefined
  shipment: any
  searchForSavedQuotes: any
  selectedOrderId?: any
  notify?: any
  callOrderShipmentsById?: any
  setMainLoadingState?: any
}

export const TabAusPost: FC<TabAusPostProps> = ({
  className,
  shipment,
  searchForSavedQuotes,
  selectedOrderId,
  notify,
  callOrderShipmentsById,
  setMainLoadingState,
}: TabAusPostProps) => {
  return (
    <div className='w-full pt-6 border-t border-t-N-200'>
      {shipment.shipmentConsignmentQuotes &&
        shipment.shipmentConsignmentQuotes.length > 0 &&
        shipment.shipmentConsignmentQuotes.map((quote: any, index: any) => {
          const obj = {
            type: quote.type,
            productName: quote.productName,
            shipmentId: shipment.id,
            productId: quote.productId,
            cost: quote.cost,
            originCharges: [
              {
                type: 'Bundle Price',
                price: quote.bundlePrice,
              },
              {
                type: 'Bundle Price Ex Gst',
                price: quote.bundlePriceExGst,
              },
              {
                type: 'Bundle Price Gst',
                price: quote.bundlePriceGst,
              },
              {
                type: 'Calculated Price',
                price: quote.calculatedPrice,
              },
              {
                type: 'Calculated Price Ex Gst',
                price: quote.calculatedPriceExGst,
              },
              {
                type: 'Calculated Price Gst',
                price: quote.calculatedPriceExGst,
              },
            ],
          }
          if (quote.type === 'AUSPOST') {
            return (
              <ShippingLineSelection
                key={index}
                isViewOnly={
                  shipment?.status === 'CLOSED' ||
                  shipment?.status === 'CANCELLED'
                }
                ShippingLineObject={obj}
                selectedOrderId={selectedOrderId}
                dateWanted={shipment?.dateWanted}
                notify={notify}
                callOrderShipmentsById={callOrderShipmentsById}
                setMainLoadingState={setMainLoadingState}
              />
            )
          }
        })}
      {shipment.shipmentConsignmentQuotes &&
        searchForSavedQuotes(shipment.shipmentConsignmentQuotes, 'AUSPOST')}
    </div>
  )
}

TabAusPost.defaultProps = {
  className: undefined,
}

export default TabAusPost
